// src/locales/pt_BR.ts
import type { LocaleData } from "../core/types";

export const pt_BR: LocaleData = {
  notEmpty: { default: "Por favor, preencha este campo" },
  email: { default: "Por favor, informe um endereço de e-mail válido" },
  creditCard: { default: "Por favor, informe um número de cartão de crédito válido" },
  date: { default: "Por favor, informe uma data válida" },
  digits: { default: "Por favor, informe apenas dígitos" },
  integer: { default: "Por favor, informe um número inteiro válido" },
  numeric: { default: "Por favor, informe um valor numérico válido" },
  regexp: { default: "Por favor, informe um valor que corresponda ao padrão exigido" },
  uri: { default: "Por favor, informe uma URL válida" },
  identical: { default: "Por favor, informe o mesmo valor" },
  different: { default: "Por favor, informe um valor diferente" },
  between: { default: "Por favor, informe um valor dentro do intervalo permitido" },
  greaterThan: { default: "Por favor, informe um valor maior ou igual ao mínimo" },
  lessThan: { default: "Por favor, informe um valor menor ou igual ao máximo" },
  stringLength: { default: "Por favor, informe um valor com o comprimento correto" },
  stringCase: {
    default: "Por favor, informe um valor com o formato de maiúsculas/minúsculas correto",
  },
  choice: { default: "Por favor, selecione o número correto de opções" },
  file: { default: "Por favor, selecione um arquivo válido" },
  callback: { default: "Por favor, informe um valor válido" },
  promise: { default: "Por favor, informe um valor válido" },
  remote: { default: "Por favor, informe um valor válido" },
  ip: { default: "Por favor, informe um endereço IP válido" },
  base64: { default: "Por favor, informe uma string Base64 válida" },
  hex: { default: "Por favor, informe um número hexadecimal válido" },
  mac: { default: "Por favor, informe um endereço MAC válido" },
  bic: { default: "Por favor, informe um código BIC/SWIFT válido" },
  uuid: { default: "Por favor, informe um UUID válido" },
  color: { default: "Por favor, informe uma cor válida" },
  step: { default: "Por favor, informe um valor de passo válido" },
  vin: { default: "Por favor, informe um VIN válido" },
  ean: { default: "Por favor, informe um número EAN válido" },
  isbn: { default: "Por favor, informe um número ISBN válido" },
  ismn: { default: "Por favor, informe um número ISMN válido" },
  issn: { default: "Por favor, informe um número ISSN válido" },
  grid: { default: "Por favor, informe um GRId válido" },
  cusip: { default: "Por favor, informe um número CUSIP válido" },
  isin: { default: "Por favor, informe um número ISIN válido" },
  sedol: { default: "Por favor, informe um número SEDOL válido" },
  imei: { default: "Por favor, informe um número IMEI válido" },
  imo: { default: "Por favor, informe um número IMO válido" },
  meid: { default: "Por favor, informe um número MEID válido" },
  ein: { default: "Por favor, informe um número EIN válido" },
  rtn: { default: "Por favor, informe um RTN válido" },
  siren: { default: "Por favor, informe um número SIREN válido" },
  siret: { default: "Por favor, informe um número SIRET válido" },
  iban: { default: "Por favor, informe um IBAN válido" },
  phone: { default: "Por favor, informe um número de telefone válido" },
  zipCode: { default: "Por favor, informe um CEP válido" },
  vat: {
    default: "Por favor, insira um número de IVA válido",
    country: "Por favor, insira um número de IVA válido para %s",
  },
  id: {
    default: "Por favor, insira um número de identificação nacional válido",
    country: "Por favor, insira um número de identificação nacional válido para %s",
  },
};
